export default __webpack_public_path__ + "static/media/song_yen.123382e2.png";